import React from "react";
import styled from "styled-components";

const PageFilterInputs: React.FC = ({ children }) => {
  return <StyledFilterInputWrapper>{children}</StyledFilterInputWrapper>;
};

const StyledFilterInputWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  height: 48px;
  flex-wrap: nowrap;
  align-items: center;
  min-width: max-content;
`;
export default PageFilterInputs;
